/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportLiquidsProcessedAvgPerDay } from './reportLiquidsProcessedAvgPerDay';
import { ReportLiquidsProcessedDaily } from './reportLiquidsProcessedDaily';


export interface ReportLiquidsProcessed { 
    avg_per_day?: ReportLiquidsProcessedAvgPerDay;
    daily_view?: Array<ReportLiquidsProcessedDaily>;
}

